"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4699],{

/***/ 14699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ topShowsWidget; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 89 modules
var swiper_esm = __webpack_require__(965);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/localization/i8intl.js + 2 modules
var i8intl = __webpack_require__(54269);
// EXTERNAL MODULE: ./src/api/commonConstants.js
var commonConstants = __webpack_require__(96781);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/homePage/topPodcastContainer.js
// import { useEffect, useState, useRef } from "react";



var NewsTopbar = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 4825).then(__webpack_require__.bind(__webpack_require__, 4825));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(4825)];
    }
  }
});

var TopPodcastContainer = function TopPodcastContainer(_ref) {
  var _topPodcastData;

  var topPodcastData = _ref.topPodcastData;
  topPodcastData = topPodcastData.slice(0, 4);
  console.log("topPodcastData", topPodcastData);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "top-pod-outer",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "topShowsTopBar",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewsTopbar, {
        videoEn: "Top Podcasts",
        videoHn: "टॉप पॉडकास्ट",
        newsIcon: "podcast-wid",
        newsBgclassName: "videoShow",
        newsBgClass: "videoShowTopBar",
        videoTitleClass: "videoTitle",
        videoImgClass: "videoImg",
        videoLinkClass: "videoLink"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "children-wrapper",
      children: (_topPodcastData = topPodcastData) === null || _topPodcastData === void 0 ? void 0 : _topPodcastData.map(function (data, index) {
        var _topPodcastData2;

        return /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
          href: "/audio/detail/".concat(data === null || data === void 0 ? void 0 : data.showSlug, "/").concat(data === null || data === void 0 ? void 0 : data.episodeSlug) // target="_blank"
          ,
          rel: "noreferrer",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "topShowsContOuter",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "left-side",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: data === null || data === void 0 ? void 0 : data.episodeImageUrl
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "right-side",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "title",
                children: data === null || data === void 0 ? void 0 : data.episodeTitle
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "buttons",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: "/assets/images/video-square.png",
                  alt: "audio-icon"
                })
              })]
            })]
          }), ((_topPodcastData2 = topPodcastData) === null || _topPodcastData2 === void 0 ? void 0 : _topPodcastData2.length) !== index + 1 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "line-newsImageTextBanner1",
            style: {
              height: "1px",
              background: "rgba(166, 166, 166, 0.2)",
              width: "90%",
              margin: "1rem auto"
            }
          })]
        }, index);
      })
    })]
  });
};

/* harmony default export */ var topPodcastContainer = (TopPodcastContainer);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/free-mode/free-mode.min.css
var free_mode_min = __webpack_require__(50094);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
;// CONCATENATED MODULE: ./src/components/homePage/topShows/topShowsWidget.js






 // Import Swiper styles







var topShowsWidget_NewsTopbar = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 4825).then(__webpack_require__.bind(__webpack_require__, 4825));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(4825)];
    }
  }
});

var TopShowsWidget = function TopShowsWidget(_ref) {
  var TopShowsWidgetData = _ref.TopShowsWidgetData,
      topPodcastData = _ref.topPodcastData;

  var _useState = (0,react.useState)(true),
      isBeginning = _useState[0],
      setIsBeginning = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isEnd = _useState2[0],
      setIsEnd = _useState2[1];

  var prevRef = (0,react.useRef)(null);
  var nextRef = (0,react.useRef)(null);

  var _useState3 = (0,react.useState)(""),
      language = _useState3[0],
      setLanguage = _useState3[1];

  var size = (0,commonConstants/* useWindowSize */.iP)();
  (0,react.useEffect)(function () {
    setLanguage((0,i8intl/* getLanguage */.G3)());
  }, []);

  var showCard = function showCard(data, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: "".concat("https://www.thelallantop.com", "/").concat(data.categorySlug, "/post/").concat(data.postSlug),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "showcard-widget",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "showcard-title",
          children: data === null || data === void 0 ? void 0 : data.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: data === null || data === void 0 ? void 0 : data.headingImageUrl
        })]
      })
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "outer-main-conainer",
      style: {
        marginTop: "1.5rem",
        marginBottom: "1.5rem"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "main-containerTopShow show-widget-alignment",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "home-left-align",
          children: [" ", /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "topShowsTopBar",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(topShowsWidget_NewsTopbar, {
              videoEn: "Top Shows",
              videoHn: "टॉप शोज़",
              newsIcon: "videoShow",
              newsBgclassName: "videoShow",
              newsBgClass: "videoShowTopBar",
              videoTitleClass: "videoTitle",
              videoImgClass: "videoImg",
              videoLinkClass: "videoLink"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "checkMobileOrNot",
            style: {
              marginTop: "-8px"
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "top-shows-widget-container ",
              children: TopShowsWidgetData === null || TopShowsWidgetData === void 0 ? void 0 : TopShowsWidgetData.map(function (data, index) {
                var _data$episodes;

                // console.log("TopShowsWidgetData11", data);
                return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "top-shows-indi-widget-container",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "widget-header",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                      className: "header-image",
                      src: data === null || data === void 0 ? void 0 : data.headingImageUrl
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "header-right",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "header-right-parta",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                          className: "episode-text",
                          children: "".concat(data === null || data === void 0 ? void 0 : data.episodesCount, " ").concat(language === "hi" ? "एपिसोड्स " : "Episodes")
                        })
                      })
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "widget-latest-strip",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      children: "".concat(language === "hi" ? (data === null || data === void 0 ? void 0 : data.titleHn) + " - लेटेस्ट एपिसोड्स" : (data === null || data === void 0 ? void 0 : data.title) + " - Latest Episodes")
                    }), " "]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "widget-show-cards",
                    children: data === null || data === void 0 ? void 0 : (_data$episodes = data.episodes) === null || _data$episodes === void 0 ? void 0 : _data$episodes.map(function (episodeData, index1) {
                      return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [" ", index1 <= 2 && showCard(episodeData, index1)]
                      });
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "line-seperator"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "read-more-container",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      href: "".concat("https://www.thelallantop.com", "/show/detail/").concat(data === null || data === void 0 ? void 0 : data.postSlug),
                      style: {
                        marginLeft: "auto"
                      },
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: "read-more-inner",
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                          children: language === "hi" ? "और देखेंं " : "View More"
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                          src: "https://static.thelallantop.com/images/post/1714633736763_vector_4.webp",
                          alt: "icon-click"
                        })]
                      })
                    })
                  })]
                }, index);
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "checkDesktopOrNot",
            style: {
              marginTop: "-8px"
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
              breakpoints: {
                0: {
                  slidesPerView: 1
                },
                400: {
                  slidesPerView: 2
                },
                639: {
                  slidesPerView: 2.8
                },
                865: {
                  slidesPerView: 3.5
                },
                1024: {
                  slidesPerView: 3.5
                },
                1200: {
                  slidesPerView: 2.2
                },
                1350: {
                  slidesPerView: 2.2
                },
                1500: {
                  slidesPerView: 2.5
                },
                1700: {
                  slidesPerView: 2.8
                }
              },
              spaceBetween: 16,
              freeMode: true // navigation={true}
              ,
              pagination: {
                clickable: true
              },
              onInit: function onInit(swiper) {
                swiper.params.navigation.prevEl = prevRef.current;
                swiper.params.navigation.nextEl = nextRef.current; // console.log(prevRef.current);
                // console.log(nextRef.current);

                swiper.on("slideChange", function () {
                  setIsBeginning(swiper.isBeginning);
                  setIsEnd(swiper.isEnd);
                });
                swiper.navigation.init();
                swiper.navigation.update();
              },
              modules: [swiper_esm/* FreeMode */.Rv, swiper_esm/* Navigation */.W_],
              className: "mySwiper shorts-slider",
              children: [TopShowsWidgetData === null || TopShowsWidgetData === void 0 ? void 0 : TopShowsWidgetData.map(function (data, index) {
                var _data$episodes2, _data$episodes3;

                return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                  children: (data === null || data === void 0 ? void 0 : (_data$episodes2 = data.episodes) === null || _data$episodes2 === void 0 ? void 0 : _data$episodes2.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    index: index,
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "top-shows-indi-widget-container",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: "widget-header",
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                          className: "header-image",
                          src: data === null || data === void 0 ? void 0 : data.headingImageUrl
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          className: "header-right",
                          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                            className: "header-right-parta",
                            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                              className: "episode-text",
                              children: "".concat(data === null || data === void 0 ? void 0 : data.episodesCount, " ").concat(language === "hi" ? "एपिसोड्स " : "Episodes")
                            }), " "]
                          })
                        })]
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: "widget-latest-strip",
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                          children: "".concat(language === "hi" ? (data === null || data === void 0 ? void 0 : data.titleHn) + " - लेटेस्ट एपिसोड्स" : (data === null || data === void 0 ? void 0 : data.title) + " - Latest Episodes")
                        }), " "]
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "widget-show-cards",
                        children: data === null || data === void 0 ? void 0 : (_data$episodes3 = data.episodes) === null || _data$episodes3 === void 0 ? void 0 : _data$episodes3.map(function (episodeData, index1) {
                          return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [" ", index1 <= 2 && showCard(episodeData, index1)]
                          });
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "read-more-container",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                          href: "".concat("https://www.thelallantop.com", "/show/detail/").concat(data === null || data === void 0 ? void 0 : data.postSlug),
                          style: {
                            marginLeft: "auto"
                          },
                          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                            className: "read-more-inner",
                            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                              children: language === "hi" ? "और देखेंं  " : "View More"
                            }), " ", /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                              src: "https://static.thelallantop.com/images/post/1714633736763_vector_4.webp",
                              alt: "icon-click"
                            })]
                          })
                        })
                      })]
                    })
                  }, index)
                });
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "shorts-slider-button-bwd",
                style: !isBeginning ? {
                  display: "block"
                } : {
                  display: "none"
                },
                ref: prevRef,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: "<"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "shorts-slider-button-fwd",
                style: !isEnd ? {
                  display: "block"
                } : {
                  display: "none"
                },
                ref: nextRef,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: ">"
                })
              })]
            })
          })]
        }), size.width <= 1024 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "gray-home-seperator"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "home-right-align",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(topPodcastContainer, {
            topPodcastData: topPodcastData
          })
        })]
      })
    })
  });
};

/* harmony default export */ var topShowsWidget = (TopShowsWidget);

/***/ })

}]);